module.exports = __webpack_public_path__ + "img/block-right-small.47644dbc.png";